import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive2Historical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { SUBMOTIVE2 } from '../../../../../routes/paths';

export const useSubmotive2Detail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idSubmotive2 } = useParams();
    const [loading, setLoading] = useState(false);
    const [submotive2, setSubmotive2] = useState<Param>();
    const [submotive2Historical, setSubmotive2Historical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idSubmotive2)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive2, 3)
                .then((submotive2: any) => {
                    if (!submotive2 || !submotive2.items) navigate(SUBMOTIVE2);
                    setSubmotive2(submotive2?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive2]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive2Historical(idSubmotive2)
                .then((resp) => {
                    if (resp) setSubmotive2Historical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        submotive2,
        submotive2Historical,
        showHistorical,
        setShowHistorical,
    };
};
